/**
 *
 * ConnectWallet
 *
 */
import { Button, Spinner } from 'app/components';
import { memo } from 'react';
import { polkaService, redirectState } from 'store/app';
import styled from 'styled-components/macro';
import { useHistory } from 'react-router';
import { useRecoilValue } from 'recoil';
import { useAddress } from 'utils/hooks/web3Hooks';
import {
  getFromLocalStorage,
  saveToLocalStorage,
} from 'utils/services/LocalStorage';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import metamask from 'assets/sprites/metamask-icon.png';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as PolkaIcon } from 'assets/images/polka-icon.svg';
import { web3Accounts } from '@polkadot/extension-dapp';
import Modal from 'app/components/Modal';
import { useAccounts } from 'utils/hooks/account';

interface Props {}

export const ConnectWallet = memo((props: Props) => {
  const history = useHistory();
  const { t } = useTranslation();
  const [address, setAddress] = useAddress();
  const redirect = useRecoilValue(redirectState);
  const [connecting, setConnecting] = useState(false);
  const [visible, setVisible] = useState(false);
  const service = useRecoilValue(polkaService);
  const accounts = useAccounts();
  //console.log('service', service);

  const connectWallet = async () => {
    setConnecting(true);
    try {
      setVisible(true);
      // if (!window.ethereum) {
      //   throw alert('You must install meta mask first');
      // }
      // const accounts = await window.ethereum.request({
      //   method: 'eth_requestAccounts',
      // });

      // const allAccounts = await web3Accounts();

      // if (accounts[0]) {
      //   saveToLocalStorage('wallet-connected', 1);
      //   setAddress(accounts[0]);
      //   if (redirect) history.push(redirect.pathname);
      //   else history.push('/');
      // }
    } finally {
      setConnecting(false);
    }
  };
  useEffect(() => {}, []);

  const selectAccount = account => {
    console.log(account);
    setAddress(account.address);
    saveToLocalStorage('account', JSON.stringify(account));
    // if (redirect) {
    //   console.log('re', redirect)
    //   history.push(redirect.pathname)
    // }
    // else {
    //   console.log('111')
    //   history.push('/')
    // };
    history.push('/');
  };
  // @ts-ignore
  return (
    <div className="min-w-screen min-h-screen flex flex-col bg-body text-white">
      <div className="flex px-16 pt-6">
        <Link to="/" className="logo flex items-center gap-2">
          <PolkaIcon />
          <span className="text-2xl font-medium">{t('appTitle', 'FiZen')}</span>
        </Link>
      </div>
      <Div className="flex-auto flex flex-col justify-center items-center gap-10">
        <img
          src="/images/connect-wallet.png"
          alt="connect your wallet"
          className="h-1/2 w-1/2"
        />
        <button
          // color="gradient"
          // size="large"
          className="neon-button flex justify-center items-center gap-4"
          // shadow
          onClick={connectWallet}
        >
          {connecting ? (
            <Spinner size="24px" />
          ) : (
            <img
              src={'/images/polkadot-icon-rm.svg'}
              alt="MetaMask icon"
              width="30px"
            />
          )}
          <span>{t('connectMetaMask', 'Connect Polkadot')}</span>
          {/*<span>→</span>*/}
        </button>
      </Div>
      <Modal visible={visible} onHide={() => setVisible(false)}>
        <div className={`flex flex-col gap-4 pb-6 bg-neutral`}>
          <div
            className={`text-left text-white px-6 py-4 font-semibold text-xl`}
          >
            Select accounts
          </div>
          <div className="flex flex-col gap-4 px-6">
            {accounts?.map((account: any, idx) => (
              <div
                className={`text-white`}
                key={account.address}
                onClick={() => selectAccount(account)}
              >
                <div
                  className={`px-6 py-4 rounded-lg text-base hover:bg-gradient-to-r from-active-300 to-active-200 hover:text-white hover:cursor-pointer`}
                >
                  <div>{account.meta.name.replace('(extension)', '')}</div>
                  <div className={`mt-2`}>{account.address}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Modal>
    </div>
  );
});

const Div = styled.div``;
